import { isString } from '@pct-ts/typeguard';
import type { ParameterValidator } from './parameter-validator';

export const stringParameterValidator: ParameterValidator = (param: unknown): boolean =>
  isString(param) && param.length > 0;
